import { motion } from "framer-motion";
import React from "react";
import { Image } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { isMobile } from "react-device-detect";
import MidBox from "../../components/Boxes/MidBox";
import Button from "../../components/Button";
import useToast from "../../hooks/useToast";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import { ContractAddress } from "../../utils/Network";

const ContractInfoCard = () => {
  const { t } = useAppTranslation(["profile", "common"]);
  const openToast = useToast();

  return (
    <motion.div
      initial={isMobile ? undefined : { opacity: 0, y: 200 }}
      transition={{
        duration: 0.3,
        delay: 0.1,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      exit={{ opacity: 0, y: -200 }}
      className="col-12 mb-2"
    >
      <MidBox modal title={t("profile:contractCard.title")}>
        {/* Heading */}
        <div className="d-flex align-items-center mb-3">
          <Image
            width={48}
            height={48}
            className="img-fluid"
            src="/assets/images/icons/cleg.png"
            alt="CLEG"
          />
          <div className="ms-3 text-start">
            <div className="text-light fw-bold fs-big">
              {t("profile:contractCard.heading")}
            </div>
            <div className="fs-small dark-gray">
              {t("profile:contractCard.subheading")}
            </div>
          </div>
        </div>

        {/* Infographic chips */}
        <div className="d-flex flex-wrap gap-2 mb-3">
          <span className="d-inline-flex align-items-center dark-bg rounded-10 px-3 py-1">
            <Image
              width={18}
              height={18}
              className="me-2"
              src="/assets/images/icons/coins/bnb.svg"
              alt="BNB Chain"
            />
            <span className="text-light fs-small fw-med">
              BNB Smart Chain (BEP-20)
            </span>
          </span>
          <span className="d-inline-flex align-items-center dark-bg rounded-10 px-3 py-1">
            <span className="dark-gray fs-small me-1">{t("profile:contractCard.chainId")}</span>
            <span className="text-light fs-small fw-med">56</span>
          </span>
          <span className="d-inline-flex align-items-center dark-bg rounded-10 px-3 py-1">
            <span className="dark-gray fs-small me-1">{t("profile:contractCard.decimals")}</span>
            <span className="text-light fs-small fw-med">18</span>
          </span>
        </div>

        {/* Address row */}
        <div className="d-flex flex-wrap align-items-center justify-content-between dark-bg rounded-10 px-3 px-md-4 py-2 mb-3">
          <div className="col-12 col-md-8 mb-2 mb-md-0 text-start">
            <div className="fs-small dark-gray">{t("profile:contractCard.address")}</div>
            <div className="dark-yellow fw-med fs-med text-wrap-force">
              {ContractAddress}
            </div>
          </div>
          <div className="col-12 col-md-4 d-flex justify-content-md-end gap-2">
            <CopyToClipboard
              text={ContractAddress}
              onCopy={() =>
                openToast({
                  ok: true,
                  data: { message: t("profile:contractCard.copied") },
                })
              }
            >
              <Button variant="default">{t("common:actions.copy")}</Button>
            </CopyToClipboard>
            <Button
              variant="default"
              onClick={() =>
                window.open(
                  `https://bscscan.com/token/${ContractAddress}`,
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              BscScan
            </Button>
          </div>
        </div>

        {/* Note */}
        <div className="fs-tiny dark-gray text-start">
          {t("profile:contractCard.warning")}
        </div>
      </MidBox>
    </motion.div>
  );
};

export default ContractInfoCard;
